module.exports = __webpack_public_path__ + "static/gold-dragon-ascendant-32d2bb86e3964b64c1ecb8d2c9885f61.jpg";